import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import Swal from "sweetalert2";
import JourneyStocksForm from "./journeyStocksForm";
import StockUnloadForm from "./stockUnloadForm";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import {
  cancelJourneyStock,
  getJourneyStocks,
} from "../../../../../services/crm/salesJourney";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { isMobile } from "react-device-detect";
function JourneyStocksData({ journey }) {
  const { reload } = useGlobalData();
  const [openStocksForm, setOpenStocksForm] = useState(false);
  const [openUnloadForm, setOpenUnloadForm] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [stock, setStock] = useState({});
  useEffect(() => {
    getActiveJourneyStocksData(journey.ID);
  }, [journey, reload]);

  const journeyStockDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {isMobile ? (
        <React.Fragment>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenStocksForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Stock Request
            </button>
          </div>
          {stocks.map((stock, index) => (
            <div key={index} onClick={() => {}}>
              <Card title={stock.itemName}>
                <table>
                  <tr>
                    <th>Warehouse</th>
                    <td>{stock.warehouse.warehouseName}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>
                      {stock.statusID === 1
                        ? "Requested"
                        : stock.statusID === 3
                        ? "Loaded"
                        : stock.statusID === 4
                        ? "Partially Returned"
                        : stock.statusID === 5
                        ? "Returned"
                        : stock.statusID === 9
                        ? "Cancelled"
                        : stock.statusID === 10
                        ? "Rejected"
                        : null}
                    </td>
                  </tr>
                  <tr>
                    <th>Item Type</th>
                    <td>{stock.itemTypeName}</td>
                  </tr>
                  <tr>
                    <th>Item Code</th>
                    <td>{stock.itemCode}</td>
                  </tr>
                  <tr>
                    <th>Qty</th>
                    <td>{stock.qty}</td>
                  </tr>
                  <tr>
                    <th>Uom</th>
                    <td>{stock.uomName}</td>
                  </tr>
                  <tr>
                    <th>Batch ID</th>
                    <td>{stock.batchID}</td>
                  </tr>
                </table>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="float-right">
                      {journey.statusID !== 3 && journey.statusID !== 9 ? (
                        <React.Fragment>
                          {stock.statusID === 3 || stock.statusID === 4 ? (
                            <BootstrapTooltip title="Stock Return">
                              <button
                                type="button"
                                onClick={() => {
                                  setStock(stock);
                                  setOpenUnloadForm(true);
                                }}
                                className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-truck-loading"></i>
                              </button>
                            </BootstrapTooltip>
                          ) : null}
                          {stock.statusID === 1 ? (
                            <BootstrapTooltip title="Delete Stock Request">
                              <button
                                type="button"
                                onClick={() => {
                                  Swal.mixin({
                                    customClass: {
                                      confirmButton:
                                        "btn btn-success btn-md btn-pill btn-bold",
                                      cancelButton:
                                        "btn btn-danger btn-md btn-pill btn-bold",
                                    },
                                    buttonsStyling: false,
                                  })
                                    .fire({
                                      title:
                                        "Are you sure want to delete this Stock Request ?",
                                      text:
                                        "Please note that you are responsible for this action",
                                      icon: "question",
                                      showCloseButton: true,
                                      showCancelButton: true,
                                      confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
                                      cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                                      reverseButtons: true,
                                    })
                                    .then((result) => {
                                      if (result.isConfirmed) {
                                        cancelJourneyStock(stock.ID).then(
                                          (response) => {
                                            Swal.mixin({
                                              customClass: {
                                                confirmButton:
                                                  "btn btn-success btn-md btn-pill btn-bold",
                                              },
                                              buttonsStyling: false,
                                            }).fire({
                                              title: "Deleted",
                                              html: response.data.message,
                                              icon: "success",
                                              showCloseButton: true,
                                              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                            });
                                            getActiveJourneyStocksData(
                                              journey.ID
                                            );
                                          }
                                        );
                                      } else if (
                                        result.dismiss ===
                                        Swal.DismissReason.cancel
                                      ) {
                                        Swal.mixin({
                                          customClass: {
                                            confirmButton:
                                              "btn btn-success btn-md btn-pill btn-bold",
                                          },
                                          buttonsStyling: false,
                                        }).fire({
                                          title: "Cancelled",
                                          text: "No change has been made",
                                          icon: "info",
                                          showCloseButton: true,
                                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                        });
                                      }
                                    });
                                }}
                                className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </BootstrapTooltip>
                          ) : null}
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {stocks.length ? (
            <React.Fragment>
              <CustomDataTable
                data={stocks}
                dataDetailColumns={journeyStockDetailColumn}
                onRefreshData={() => {
                  getActiveJourneyStocksData(journey.ID);
                }}
                buttons={
                  journey.statusID !== 3 && journey.statusID !== 9
                    ? [
                        {
                          name: "New Stock Request",
                          icon: "fas fa-plus-circle",
                          color: "primary",
                          onClick: () => {
                            setOpenStocksForm(true);
                          },
                        },
                      ]
                    : []
                }
                columns={[
                  {
                    header: "Request ID",
                    field: "itemRequestID",
                    body: null,
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Source Warehouse",
                    field: "warehouse.warehouseName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.warehouse.warehouseName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Item Type",
                    field: "itemTypeName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemTypeName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                    hidden: true,
                  },
                  {
                    header: "Item Code",
                    field: "itemCode",
                    body: (rowData) => (
                      <React.Fragment>
                        {rowData.itemType > 0 ? (
                          <span>
                            <BootstrapTooltip title={rowData.itemTypeName}>
                              <span className="mr-2">
                                <i
                                  className={
                                    rowData.itemType === 1
                                      ? "fas fa-boxes text-success"
                                      : rowData.itemType === 2
                                      ? "fas fa-tools text-primary"
                                      : rowData.itemType === 3
                                      ? "fas fa-building text-info"
                                      : rowData.itemType === 4
                                      ? "fas fa-boxes text-warning"
                                      : rowData.itemType === 5
                                      ? "fas fa-boxes text-danger"
                                      : null
                                  }
                                ></i>
                              </span>
                            </BootstrapTooltip>
                            <span>
                              <ResponsiveEllipsis
                                text={rowData.itemCode}
                                maxLine="1"
                                displayInline
                              />
                            </span>
                          </span>
                        ) : (
                          <React.Fragment>
                            <ResponsiveEllipsis
                              text={rowData.itemCode}
                              maxLine="1"
                            />
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Item Name",
                    field: "itemName",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemName}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Request Status",
                    field: "statusID",
                    body: (rowData) => (
                      <React.Fragment>
                        <Badge
                          variant={
                            rowData.statusID === 1
                              ? "info"
                              : rowData.statusID === 3
                              ? "success"
                              : rowData.statusID === 4
                              ? "warning"
                              : rowData.statusID === 5
                              ? "primary"
                              : rowData.statusID === 9
                              ? "danger"
                              : rowData.statusID === 10
                              ? "danger"
                              : null
                          }
                        >
                          {rowData.statusID === 1
                            ? "Requested"
                            : rowData.statusID === 3
                            ? "Loaded"
                            : rowData.statusID === 4
                            ? "Partially Returned"
                            : rowData.statusID === 5
                            ? "Returned"
                            : rowData.statusID === 9
                            ? "Cancelled"
                            : rowData.statusID === 10
                            ? "Rejected"
                            : null}
                        </Badge>
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Quantity",
                    field: "qty",
                    body: (rowData) => (
                      <div>
                        {rowData.qty} {rowData.uomName}
                      </div>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Unit",
                    field: "uomName",
                    body: null,
                    sortable: true,
                    filter: true,
                    hidden: true,
                  },
                  {
                    header: "Batch ID",
                    field: "batchID",
                    body: null,
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Actions",
                    body: (rowData) => (
                      <React.Fragment>
                        {journey.statusID !== 3 && journey.statusID !== 9 ? (
                          <React.Fragment>
                            {rowData.statusID === 3 ||
                            rowData.statusID === 4 ? (
                              <BootstrapTooltip title="Stock Return">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setStock(rowData);
                                    setOpenUnloadForm(true);
                                  }}
                                  className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                                >
                                  <i className="fas fa-truck-loading"></i>
                                </button>
                              </BootstrapTooltip>
                            ) : null}
                            {rowData.statusID === 1 ? (
                              <BootstrapTooltip title="Delete Stock Request">
                                <button
                                  type="button"
                                  onClick={() => {
                                    Swal.mixin({
                                      customClass: {
                                        confirmButton:
                                          "btn btn-success btn-md btn-pill btn-bold",
                                        cancelButton:
                                          "btn btn-danger btn-md btn-pill btn-bold",
                                      },
                                      buttonsStyling: false,
                                    })
                                      .fire({
                                        title:
                                          "Are you sure want to delete this Stock Request ?",
                                        text:
                                          "Please note that you are responsible for this action",
                                        icon: "question",
                                        showCloseButton: true,
                                        showCancelButton: true,
                                        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
                                        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                                        reverseButtons: true,
                                      })
                                      .then((result) => {
                                        if (result.isConfirmed) {
                                          cancelJourneyStock(rowData.ID).then(
                                            (response) => {
                                              Swal.mixin({
                                                customClass: {
                                                  confirmButton:
                                                    "btn btn-success btn-md btn-pill btn-bold",
                                                },
                                                buttonsStyling: false,
                                              }).fire({
                                                title: "Deleted",
                                                html: response.data.message,
                                                icon: "success",
                                                showCloseButton: true,
                                                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                              });
                                              getActiveJourneyStocksData(
                                                journey.ID
                                              );
                                            }
                                          );
                                        } else if (
                                          result.dismiss ===
                                          Swal.DismissReason.cancel
                                        ) {
                                          Swal.mixin({
                                            customClass: {
                                              confirmButton:
                                                "btn btn-success btn-md btn-pill btn-bold",
                                            },
                                            buttonsStyling: false,
                                          }).fire({
                                            title: "Cancelled",
                                            text: "No change has been made",
                                            icon: "info",
                                            showCloseButton: true,
                                            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                          });
                                        }
                                      });
                                  }}
                                  className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </BootstrapTooltip>
                            ) : null}
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    ),
                    sortable: false,
                  },
                ]}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Illustration
                imageSource="INVIFO Inventory.png"
                description="Hooray! You're ready to have your first Stock Request to warehouses!"
                guidance="Hint: request products from warehouses and offer the products to your valuable customer during the sales journey"
                descriptionLeftIcon="fas fa-info-circle kt-font-success"
                size="md"
              ></Illustration>
              <div className="text-center py-3">
                <button
                  type="button"
                  className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                  onClick={() => {
                    setOpenStocksForm(true);
                  }}
                >
                  <i className="fas fa-plus-circle"></i>
                  New Stock Request
                </button>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
      <DialogLayout
        open={openStocksForm}
        title="Stock Request Form"
        onCloseDialog={handleCloseStocksForm}
        fullScreen={false}
      >
        <JourneyStocksForm
          journeyID={journey.ID}
          onConfirmSave={() => {
            getActiveJourneyStocksData(journey.ID);
            handleCloseStocksForm();
          }}
          onCloseStocksForm={handleCloseStocksForm}
        />
      </DialogLayout>
      <DialogLayout
        open={openUnloadForm}
        title="Stock Return Form"
        onCloseDialog={handleCloseUnloadForm}
        fullScreen={false}
      >
        <StockUnloadForm
          stock={stock}
          onCloseUnloadForm={handleCloseUnloadForm}
          onConfirmSave={handleCloseUnloadForm}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function getActiveJourneyStocksData(journeyID) {
    const response = await getJourneyStocks(journeyID, "all");
    const { data } = response.data;
    setStocks(data.journeyStocks);
  }

  function handleCloseStocksForm() {
    setOpenStocksForm(false);
  }

  function handleCloseUnloadForm() {
    setOpenUnloadForm(false);
  }
}

export default JourneyStocksData;
